module.exports = __webpack_public_path__ + "img/198.aa71382d.jpg";